/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateVolunteerRequest,
  ProblemDetails,
  SearchResultsOfVolunteerSearchResult,
  UpdateVolunteerRequest,
  ValidationProblemDetails,
  VolunteerAssignedClientResponse,
  VolunteerResponse,
} from '../models/index';
import {
    CreateVolunteerRequestFromJSON,
    CreateVolunteerRequestToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    SearchResultsOfVolunteerSearchResultFromJSON,
    SearchResultsOfVolunteerSearchResultToJSON,
    UpdateVolunteerRequestFromJSON,
    UpdateVolunteerRequestToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
    VolunteerAssignedClientResponseFromJSON,
    VolunteerAssignedClientResponseToJSON,
    VolunteerResponseFromJSON,
    VolunteerResponseToJSON,
} from '../models/index';

export interface CreateVolunteerOperationRequest {
    createVolunteerRequest: CreateVolunteerRequest;
}

export interface DeleteVolunteerRequest {
    id: string;
}

export interface GetVolunteerAssignedClientsRequest {
    id: string;
}

export interface GetVolunteerByIdRequest {
    id: string;
}

export interface SearchVolunteersRequest {
    searchText?: string;
}

export interface UpdateVolunteerOperationRequest {
    id: string;
    updateVolunteerRequest: UpdateVolunteerRequest;
}

/**
 * VolunteersApi - interface
 * 
 * @export
 * @interface VolunteersApiInterface
 */
export interface VolunteersApiInterface {
    /**
     * 
     * @param {CreateVolunteerRequest} createVolunteerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VolunteersApiInterface
     */
    createVolunteerRaw(requestParameters: CreateVolunteerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VolunteerResponse>>;

    /**
     */
    createVolunteer(requestParameters: CreateVolunteerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VolunteerResponse>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VolunteersApiInterface
     */
    deleteVolunteerRaw(requestParameters: DeleteVolunteerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteVolunteer(requestParameters: DeleteVolunteerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VolunteersApiInterface
     */
    getVolunteerAssignedClientsRaw(requestParameters: GetVolunteerAssignedClientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<VolunteerAssignedClientResponse>>>;

    /**
     */
    getVolunteerAssignedClients(requestParameters: GetVolunteerAssignedClientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<VolunteerAssignedClientResponse>>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VolunteersApiInterface
     */
    getVolunteerByIdRaw(requestParameters: GetVolunteerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VolunteerResponse>>;

    /**
     */
    getVolunteerById(requestParameters: GetVolunteerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VolunteerResponse>;

    /**
     * 
     * @param {string} [searchText] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VolunteersApiInterface
     */
    searchVolunteersRaw(requestParameters: SearchVolunteersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchResultsOfVolunteerSearchResult>>;

    /**
     */
    searchVolunteers(requestParameters: SearchVolunteersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchResultsOfVolunteerSearchResult>;

    /**
     * 
     * @param {string} id 
     * @param {UpdateVolunteerRequest} updateVolunteerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VolunteersApiInterface
     */
    updateVolunteerRaw(requestParameters: UpdateVolunteerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VolunteerResponse>>;

    /**
     */
    updateVolunteer(requestParameters: UpdateVolunteerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VolunteerResponse>;

}

/**
 * 
 */
export class VolunteersApi extends runtime.BaseAPI implements VolunteersApiInterface {

    /**
     */
    async createVolunteerRaw(requestParameters: CreateVolunteerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VolunteerResponse>> {
        if (requestParameters['createVolunteerRequest'] == null) {
            throw new runtime.RequiredError(
                'createVolunteerRequest',
                'Required parameter "createVolunteerRequest" was null or undefined when calling createVolunteer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/volunteers`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateVolunteerRequestToJSON(requestParameters['createVolunteerRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VolunteerResponseFromJSON(jsonValue));
    }

    /**
     */
    async createVolunteer(requestParameters: CreateVolunteerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VolunteerResponse> {
        const response = await this.createVolunteerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteVolunteerRaw(requestParameters: DeleteVolunteerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteVolunteer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/volunteers/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteVolunteer(requestParameters: DeleteVolunteerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteVolunteerRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getVolunteerAssignedClientsRaw(requestParameters: GetVolunteerAssignedClientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<VolunteerAssignedClientResponse>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getVolunteerAssignedClients().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/volunteers/{id}/assigned-clients`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(VolunteerAssignedClientResponseFromJSON));
    }

    /**
     */
    async getVolunteerAssignedClients(requestParameters: GetVolunteerAssignedClientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<VolunteerAssignedClientResponse>> {
        const response = await this.getVolunteerAssignedClientsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getVolunteerByIdRaw(requestParameters: GetVolunteerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VolunteerResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getVolunteerById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/volunteers/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VolunteerResponseFromJSON(jsonValue));
    }

    /**
     */
    async getVolunteerById(requestParameters: GetVolunteerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VolunteerResponse> {
        const response = await this.getVolunteerByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchVolunteersRaw(requestParameters: SearchVolunteersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchResultsOfVolunteerSearchResult>> {
        const queryParameters: any = {};

        if (requestParameters['searchText'] != null) {
            queryParameters['SearchText'] = requestParameters['searchText'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/volunteers`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchResultsOfVolunteerSearchResultFromJSON(jsonValue));
    }

    /**
     */
    async searchVolunteers(requestParameters: SearchVolunteersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchResultsOfVolunteerSearchResult> {
        const response = await this.searchVolunteersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateVolunteerRaw(requestParameters: UpdateVolunteerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VolunteerResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateVolunteer().'
            );
        }

        if (requestParameters['updateVolunteerRequest'] == null) {
            throw new runtime.RequiredError(
                'updateVolunteerRequest',
                'Required parameter "updateVolunteerRequest" was null or undefined when calling updateVolunteer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/volunteers/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateVolunteerRequestToJSON(requestParameters['updateVolunteerRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VolunteerResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateVolunteer(requestParameters: UpdateVolunteerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VolunteerResponse> {
        const response = await this.updateVolunteerRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
